import React, { FC } from 'react';
import mainCss from './styles/side-navigation.scss';
import css from './styles/side-navigation-links.scss';
import creditSearch from '../../assets/images/credit-search.svg';
import freight from '../../assets/images/freight.svg';
import fuel from '../../assets/images/fuel.svg';
import banking from '../../assets/images/banking.svg';
import factoring from '../../assets/images/factoring.svg';
import proTransport from '../../assets/images/pro-transport.svg';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import FirebaseAnalytics from '../core/analytics';
import { useSelector } from 'react-redux';
import { RootState } from 'bootstrap';
import Permission from '../../components/core/permission';
import { SideNavigationLink } from './side-navigation-link';
import { getDeviceType, FF } from '../../utils/utils';
import { getIsSideNavigationCollapsed } from '../../redux/actions/appActions';

export const SideNavigationLinks: FC = () => {
  const { t } = useTranslation();
  const isCollapsed = useSelector(getIsSideNavigationCollapsed);
  const permissions = useSelector((state: RootState) => state.app.permissions);
  const tmsPremiumUser = !!permissions?.includes('ProTransportWeb.user') || !!permissions?.includes('tms.user.premium');
  const tmsEnterpriseUser =
    !!permissions?.includes('ProTransportWeb.user.enterprise') || !!permissions?.includes('tms.user.enterprise');
  const isOOIDAUser = useSelector((state: RootState) => state.app.user.company_id === '9070076');
  const features = useSelector<RootState, string[]>((state) => state.app.features);
  const BSS7465 = features.includes(FF.BANKING);
  const isBankingUser = BSS7465 && permissions?.includes('banking.User');

  let loadsTitle = t('sideNavigation.basic');
  if (tmsEnterpriseUser) {
    loadsTitle = t('sideNavigation.enterprise');
  } else if (tmsPremiumUser) {
    loadsTitle = t('sideNavigation.premium');
  }

  const onLinkClicked = (label: string, tab: number) => {
    const { width, height } = window.screen;
    FirebaseAnalytics.sendEvent(
      FirebaseAnalytics.EVENTS.CLICK,
      FirebaseAnalytics.MODULES.RTSPRO,
      FirebaseAnalytics.PAGES.MAIN_NAVIGATION,
      {
        label,
        resolution: `${width}X${height}`,
        browserType: getDeviceType(),
      },
    );
  };

  return (
    <>
      <SideNavigationLink
        to="/credit"
        onClick={() => onLinkClicked(FirebaseAnalytics.MODULES.CREDIT, 0)}
        isSelected={window.location.pathname.startsWith('/credit')}
        imgSrc={creditSearch}
        title={t('sideNavigation.credit_search')}
      />
      <SideNavigationLink
        to="/freight"
        onClick={() => onLinkClicked(FirebaseAnalytics.MODULES.FREIGHT, 1)}
        isSelected={window.location.pathname.startsWith('/freight')}
        imgSrc={freight}
        title={t('sideNavigation.freight')}
      />
      <Permission permission="fuel.Access" withTrial={true}>
        <SideNavigationLink
          to="/fuel"
          onClick={() => onLinkClicked(FirebaseAnalytics.MODULES.FUEL, 2)}
          isSelected={window.location.pathname.startsWith('/fuel')}
          imgSrc={fuel}
          title={t('sideNavigation.fuel')}
        />
      </Permission>
      <SideNavigationLink
        to="/factoring"
        onClick={() => onLinkClicked(FirebaseAnalytics.MODULES.FACTORING, 3)}
        isSelected={window.location.pathname.startsWith('/factoring')}
        imgSrc={factoring}
        title={t('sideNavigation.factoring')}
      />
      {!isOOIDAUser && (
        <NavLink to="/loads" onClick={() => onLinkClicked(FirebaseAnalytics.MODULES.LOADS, 4)}>
          <div
            className={classNames(
              css.proTransport,
              window.location.pathname.startsWith('/loads') && css.proTransportSelected,
              isCollapsed && css.collapsed,
            )}
          >
            <img src={proTransport} className={css.proTransportIcon} />
            {!isCollapsed && (
              <>
                <span className={mainCss.title}>{t('sideNavigation.pro_transport')}</span>
                <div className={css.premium}>{loadsTitle}</div>
              </>
            )}
          </div>
        </NavLink>
      )}
      {isBankingUser && (
        <div className={css.bankingWrapper}>
          <SideNavigationLink
            to="/banking"
            onClick={() => onLinkClicked(FirebaseAnalytics.MODULES.BANKING, 5)}
            isSelected={window.location.pathname.startsWith('/banking')}
            imgSrc={banking}
            title={t('sideNavigation.banking')}
          />
        </div>
      )}
    </>
  );
};
